<template>
  <div>
    <div class="d-flex justify-end" v-if="!createMode && !editMode">
      <div class="mr-auto" v-if="node.meta.question">
        {{ node.meta.question }}
      </div>
      <div class="mr-auto">{{ node.name }}</div>
      <span>
        <div class="mr-auto" v-if="node.meta.comment">
          {{ node.meta.comment }}
        </div>
        <div class="mr-auto font-weight-light text-caption">
          {{ showAuthor() }}
        </div>
        <v-menu
          ref="menu"
          v-model="menu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
          :disabled="!editMode"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="date"
              label="event date"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="date"
            :active-picker.sync="activePicker"
            :max="
              new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
                .toISOString()
                .substr(0, 10)
            "
            min="1920-01-01"
            @change="changeValue($event, node)"
          ></v-date-picker>
        </v-menu>
      </span>
    </div>
    <div v-if="editMode && !createMode">
      <div class="d-flex justify-end">
        <div class="mr-auto pr-2" v-if="node.meta.question">
          {{ node.meta.question }}
        </div>
        <div class="mr-auto pr-2">{{ node.name }}</div>
        <span>
          <div class="mr-auto pr-2" v-if="node.meta.comment">
            {{ node.meta.comment }}
          </div>
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="date"
                label="event date"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="date"
              :active-picker.sync="activePicker"
              :max="
                new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
                  .toISOString()
                  .substr(0, 10)
              "
              min="1920-01-01"
              @change="changeValue($event, node)"
            ></v-date-picker>
          </v-menu>
        </span>
      </div>
    </div>
    <v-form ref="form" v-if="createMode" class="full-width">
      <v-row>
        <v-col>
          <div class="d-flex justify-space-between full-width">
            <v-text-field
              label="Question (optional)"
              v-model="node.meta.question"
              class="mr-4"
            ></v-text-field>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <div class="d-flex justify-space-between full-width">
            <v-text-field
              label="Comment (optional)"
              v-model="node.meta.comment"
              class="mr-4"
            ></v-text-field>
          </div>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    node: Object,
    editMode: Boolean,

    createMode: { type: Boolean, default: false, required: false },
    selectedRecord: Object,
    isRoot: Boolean,
  },
  mounted() {
    this.$emit("validation", true);
    if (this.node.value.length > 0) {
      this.date = this.node.value;
    }
  },
  computed: {
    ...mapGetters({
      loginDetails: "getUser",
      getName: "getLoggedInName",
    }),

    defaultDate: function() {
      if (this.node.value.length > 0) {
        this.date = this.node.value;
      }
      return new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10);
    },
  },
  data() {
    return {
      activePicker: null,
      date: this.defaultDate,
      menu: false,
    };
  },
  watch: {
    menu(val) {
      val && setTimeout(() => (this.activePicker = "YEAR"));
    },
  },
  methods: {
    changeValue(e) {
      this.$refs.menu.save(this.date);
      if (!e) {
        return;
      }
      this.node.value = e;
      this.node.authorName = this.getName;
      this.node.authorId = this.loginDetails.id;

      this.$emit("updateconditionalnodes");
      this.$root.$emit("edit:update");
    },
    showAuthor() {
      if (this.node.authorName) {
        return ` Last changed by ${this.node.authorName}`;
      }
      return "";
    },
  },
};
</script>

<style></style>
